import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

const SSOCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // SEC-06: the backend already set the httpOnly session cookie on the
    // redirect that landed us here — nothing to read out of the URL anymore.
    api.get('/auth/me')
      .then(() => {
        window.location.href = '/dashboard';
      })
      .catch(() => navigate('/login?error=sso_failed'));
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#060d1f', color: '#fff', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 40, height: 40, border: '3px solid rgba(255,255,255,0.2)', borderTopColor: '#3b82f6', borderRadius: '50%', margin: '0 auto 16px', animation: 'spin 0.8s linear infinite' }} />
        <div style={{ fontSize: 15 }}>Signing you in…</div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default SSOCallback;
